import { useContext } from 'react';
import { DimeStateContext } from './../store';
export var useDimeConvertedToPaid = function () {
    var context = useContext(DimeStateContext);
    // Calling from outside the context (ie v1) will result in an undefined context
    return context === null || context === void 0 ? void 0 : context.convertedToPaid;
};
//# sourceMappingURL=useDimeConvertedToPaid.js.map